export default __webpack_public_path__ + "static/media/index-coop.6338e3a0.jpg";